export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('MOUVMENT_CLIENT_CAN_CANCEL_ONLY_PAYMENT') === 0
      && !messages.find((message) => {
        return message.message === 'ajoutEditContrat.echeancier.popupAnnulationPaiement.errors.canOnlyCancelPaiement';
      })) {
      messages.push({
        message: 'ajoutEditContrat.echeancier.popupAnnulationPaiement.errors.canOnlyCancelPaiement',
      });
    }
    if (message.indexOf('MOUVEMENT_CLIENT_CAN_CANCEL_ONLY_PAIEMENT_LINK_WITH_BILL') === 0
      && !messages.find((message) => {
        return message.message === 'ajoutEditContrat.echeancier.popupAnnulationPaiement.errors.canOnlyCancelPaiementLinedWithBill';
      })) {
      messages.push({
        message: 'ajoutEditContrat.echeancier.popupAnnulationPaiement.errors.canOnlyCancelPaiementLinedWithBill',
      });
    }
  });
}
